module.exports = __webpack_public_path__ + "img/avatar-7.cc5ce0f0.jpg";